import { dataTimesCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTimesCircleSolid = /*#__PURE__*/createIcon(dataTimesCircleSolid)
export default IconTimesCircleSolid
